export const borderRadiusSettings = {
    default: 4,
    rounded: 30,
    hard: 0,
};
export const heightSettings = {
    small: 25,
    default: 36,
};
export const fontSettings = {
    small: 12,
    default: 16,
};
